import type { ReactNode } from 'react'
import type { Permission } from '../../types/permissions'
import usePermissions from '../../hooks/usePermissions'

interface PermissionGateProps {
  permission: Permission
  children: ReactNode
  fallback?: ReactNode
}

const PermissionGate = ({ permission, children, fallback = null }: PermissionGateProps): React.JSX.Element => {
  const { can } = usePermissions()
  return <>{can(permission) ? children : fallback}</>
}

export default PermissionGate
